import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-trash\"><path fill-rule=\"evenodd\" d=\"M7.5 1.125v-.75h-3v.75H.75v1.5H1.8l.426 8.525a.5.5 0 0 0 .5.475h6.548a.5.5 0 0 0 .5-.475l.426-8.525h1.05v-1.5zm-3.75 7.5v-4.5h1.5v4.5zm3 0v-4.5h1.5v4.5z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol